import React from "react";
import { ISearchAddress } from "./util";

interface SearchLocationPreviewProps {
    address: ISearchAddress;
    specificZip: boolean;
    specificCity: boolean;
    specificCounty: boolean;
    specificState: boolean;
}

export const SearchLocationPreview: React.FC<SearchLocationPreviewProps> = props => {
    const { address, specificZip, specificCity, specificCounty, specificState } = props;
    if (specificZip) return <span>In {address.zip}</span>;
    if (specificCity)
        return (
            <span>
                In {address.city}, {address.state}
            </span>
        );
    if (specificCounty)
        return (
            <span>
                In {address.county}, {address.state}
            </span>
        );
    if (specificState) return <span>In {address.state}</span>;
    return (
        <span>
            {address.city && address.city.length ? (
                <span>
                    Near {address.city}
                    {address.state && address.state.length && `, ${address.state}`}
                </span>
            ) : address.zip ? (
                <span>Near {address.zip}</span>
            ) : (
                <span>Near {address.state}</span>
            )}
        </span>
    );
};
